var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.subscription
      ? _c("div", { staticClass: "zw-payment-collection" }, [
          _c(
            "div",
            {
              staticClass: "ui zw-payment segment",
              class: { loading: _vm.showLoader },
              on: { click: _vm.loadPaymentInfo }
            },
            [
              _c("div", { staticClass: "status" }, [
                _c("a", { class: [_vm.statusClass, "ui empty circular label"] })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "date" }, [
                _c("div", { staticClass: "ui mini statistic" }, [
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.getTransactionDate) +
                        "\n\t\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.getTransactionMonth) +
                        "\n\t\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.getTransactionYear) +
                        "\n\t\t\t\t\t\t"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "merchant" }, [
                _c("h3", { staticClass: "ui header" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.getSubscriptionName) +
                      "\n            "
                  ),
                  _vm.transaction.payment_purpose === "overdue_fee"
                    ? _c("span", [
                        _vm._v(
                          "\n              (" +
                            _vm._s(
                              _vm.$t("components.transaction.info.overdue_fee")
                            ) +
                            ")\n            "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.transaction.status === "overdue" &&
                  _vm.subscription.product.overdue_fee_amount !== null &&
                  _vm.subscription.apply_overdue_fee
                    ? _c(
                        "div",
                        {
                          staticClass: "overdue_fee",
                          staticStyle: { color: "orange", "font-size": "1rem" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "components.transaction.info.overdue_fee"
                                )
                              ) +
                              ": " +
                              _vm._s(
                                _vm.formatPrice(
                                  _vm.subscription.product.overdue_fee_amount
                                )
                              ) +
                              " DKK\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub header" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.statusMessage) +
                        "\n\t\t\t\t\t\t"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "amount" }, [
                _c("h3", { staticClass: "ui header" }, [
                  this.transaction.status === "refunded"
                    ? _c("span", [
                        _vm._v(
                          "\n              - " +
                            _vm._s(_vm.formatPrice(_vm.amount)) +
                            "\n            "
                        )
                      ])
                    : _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.formatPrice(_vm.amount)) +
                            "\n            "
                        )
                      ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sub header" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm.getCurrency) +
                        "\n\t\t\t\t\t\t"
                    )
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _vm.showPaymentInfo
            ? _c("div", { staticClass: "ui padded segment zw-payment-info" }, [
                _c("div", { staticClass: "ui two column stackable grid" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("h3", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("components.transaction.info.paymentinfo")
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _vm.transaction.status === "success" ||
                      _vm.transaction.status === "pending"
                        ? _c("span", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("components.transaction.info.paid", {
                                    date: _vm.getDateString,
                                    time: _vm.getTimeString
                                  })
                                ) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ])
                        : _vm.transaction.status === "refunded"
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "components.transaction.info.refunded",
                                    {
                                      date: _vm.getDateString,
                                      time: _vm.getTimeString
                                    }
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        : _vm.transaction.status === "refunding"
                        ? _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "components.transaction.info.refunding"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        : _vm.transaction.status === "failed" ||
                          _vm.transaction.status === "soft_overdue" ||
                          _vm.transaction.status === "overdue"
                        ? _c("span", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("components.transaction.info.tried", {
                                    date: _vm.getDateString,
                                    time: _vm.getTimeString
                                  })
                                ) +
                                "\n                "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "components.transaction.info.fail_reason",
                                    { reason: _vm.getFailTransactionReason }
                                  )
                                ) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.showDownloadPdf
                      ? _c("div", { staticClass: "ui header" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  return _vm.downloadInvoice()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\tDownload pdf\n\t\t\t\t\t\t\t"
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedAccessories.length > 0
                      ? _c("div", { staticClass: "ui header" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "components.transaction.info.accessories"
                                )
                              ) +
                              "\n\t\t\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedAccessories.length > 0
                      ? _c(
                          "div",
                          { staticClass: "content" },
                          _vm._l(_vm.selectedAccessories, function(accessory) {
                            return _c(
                              "div",
                              {
                                key: accessory.id,
                                staticClass: "ui green label"
                              },
                              [_vm._v(_vm._s(accessory.name))]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c("h3", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("components.transaction.info.merchantinfo")
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "ui list" }, [
                        _c("div", { staticClass: "item" }, [
                          _vm._v(_vm._s(_vm.activeMerchant.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "tel:" + _vm.activeMerchant.phone }
                            },
                            [_vm._v(_vm._s(_vm.activeMerchant.phone))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "item",
                            staticStyle: { "word-break": "break-all" }
                          },
                          [_vm._v(_vm._s(_vm.activeMerchant.email))]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("h3", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.$t("components.transaction.info.purchase")
                          ) +
                          "\n\t\t\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _vm.transaction.payment_purpose === "overdue_fee"
                          ? [
                              _c("div", { staticClass: "ui two column grid" }, [
                                _c(
                                  "div",
                                  { staticClass: "left aligned column" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "components.transaction.info.overdue_fee"
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "right aligned column" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.formatPrice(
                                            _vm.transaction.amount
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.getCurrency) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ])
                            ]
                          : [
                              _c("div", { staticClass: "ui two column grid" }, [
                                _c(
                                  "div",
                                  { staticClass: "left aligned column" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.subscription.product.name) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "right aligned column" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.getProductPriceFromTotalPrice(
                                            _vm.subscription,
                                            _vm.transaction,
                                            _vm.amount
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                    _vm.hasTransactionKamstrupUsage
                                      ? [
                                          _vm._v(" / m"),
                                          _c("sup", [_vm._v("3")])
                                        ]
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.getCurrency) +
                                        "\n                  "
                                    )
                                  ],
                                  2
                                )
                              ]),
                              _vm._v(" "),
                              _vm.subscription.product.apply_vat
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "ui two column grid",
                                      staticStyle: { "margin-top": "-2rem" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "left aligned column" },
                                        [
                                          _vm._v(
                                            "\n                    25,00% moms:\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "right aligned column" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.getProductPriceVatFromTotalPrice(
                                                  _vm.subscription,
                                                  _vm.transaction,
                                                  _vm.amount
                                                )
                                              ) +
                                              "\n                    "
                                          ),
                                          _vm.hasTransactionKamstrupUsage
                                            ? [
                                                _vm._v(" / m"),
                                                _c("sup", [_vm._v("3")])
                                              ]
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.getCurrency) +
                                              "\n                  "
                                          )
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedAccessories.length > 0
                                ? _vm._l(_vm.selectedAccessories, function(
                                    accessory
                                  ) {
                                    return _c("div", { key: accessory.id }, [
                                      _c(
                                        "div",
                                        { staticClass: "ui two column grid" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "left aligned column"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(accessory.name) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "right aligned column"
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.getAccessoryPrice(
                                                      accessory
                                                    )
                                                  ) +
                                                  "\n                        "
                                              ),
                                              _vm.hasTransactionKamstrupUsage &&
                                              accessory.water_tax
                                                ? [
                                                    _vm._v(" / m"),
                                                    _c("sup", [_vm._v("3")])
                                                  ]
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(_vm.getCurrency) +
                                                  "\n                      "
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      accessory.apply_vat
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "ui two column grid",
                                              staticStyle: {
                                                "margin-top": "-2rem"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "left aligned column"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        25,00% moms:\n                      "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "right aligned column"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.getAccessoryPriceVat(
                                                          accessory
                                                        )
                                                      ) +
                                                      "\n                        "
                                                  ),
                                                  _vm.hasTransactionKamstrupUsage &&
                                                  accessory.water_tax
                                                    ? [
                                                        _vm._v(" / m"),
                                                        _c("sup", [_vm._v("3")])
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(_vm.getCurrency) +
                                                      "\n                      "
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.subscription.expire_date
                                ? _c(
                                    "div",
                                    { staticClass: "ui two column grid" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "left aligned column",
                                          staticStyle: { color: "green" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "components.transaction.info.expire_date"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "right aligned column",
                                          staticStyle: { color: "green" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.getExpireDate) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "ui two column grid" }, [
                                _c("div", {
                                  staticClass: "two wide left aligned column"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "fourteen wide column" },
                                  [
                                    false
                                      ? _c(
                                          "table",
                                          {
                                            staticClass:
                                              "ui very basic borderless compact table"
                                          },
                                          [
                                            _c(
                                              "tbody",
                                              [
                                                _vm._l(
                                                  _vm.selectedAccessories,
                                                  function(accessory) {
                                                    return _c(
                                                      "tr",
                                                      { key: accessory.id },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "left aligned"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                accessory.name
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "right aligned"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.formatPrice(
                                                                  accessory
                                                                    .pricing
                                                                    .price
                                                                )
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  accessory
                                                                    .pricing
                                                                    .currency
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "left aligned"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.subscription
                                                            .product.name
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "right aligned"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatPrice(
                                                            _vm.subscription
                                                              .pricing.price
                                                          )
                                                        ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.getCurrency
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _vm.hasTransactionKamstrupUsage
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "ui two column grid",
                                      staticStyle: { "margin-top": "-0.5rem" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "left aligned column" },
                                        [_c("b", [_vm._v("Pris inkl. moms")])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "right aligned column" },
                                        [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatPrice(
                                                  _vm.transactionUnitPriceWithVat
                                                )
                                              ) + " / m"
                                            ),
                                            _c("sup", [_vm._v("3")]),
                                            _vm._v(
                                              " " + _vm._s(_vm.getCurrency)
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                        _vm._v(" "),
                        _c("div", { staticClass: "ui divider" }),
                        _vm._v(" "),
                        _c(
                          "table",
                          {
                            staticClass:
                              "ui very basic borderless compact table"
                          },
                          [
                            _c("tbody", [
                              _vm.hasTransactionKamstrupUsage
                                ? _c("tr", [
                                    _c("td", { staticClass: "left aligned" }, [
                                      _vm._v("Vandforbrug")
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "right aligned" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.transactionKamstrupMeterReadingTotal
                                        ) + " m"
                                      ),
                                      _c("sup", [_vm._v("3")])
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { staticClass: "left aligned" }, [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "components.transaction.info.total"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "right aligned" }, [
                                  _vm.transaction.status === "refunded"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                      - " +
                                            _vm._s(
                                              _vm.formatPrice(_vm.amount)
                                            ) +
                                            " " +
                                            _vm._s(_vm.getCurrency) +
                                            "\n                    "
                                        )
                                      ])
                                    : _c(
                                        "span",
                                        [
                                          _vm.transaction.status ===
                                            "overdue" &&
                                          _vm.subscription.product
                                            .overdue_fee_amount !== null &&
                                          _vm.subscription.apply_overdue_fee
                                            ? [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.formatPrice(
                                                        _vm.amount
                                                      )
                                                    ) +
                                                    " (+ " +
                                                    _vm._s(
                                                      _vm.formatPrice(
                                                        _vm.subscription.product
                                                          .overdue_fee_amount
                                                      )
                                                    ) +
                                                    ") " +
                                                    _vm._s(_vm.getCurrency) +
                                                    "\n                      "
                                                )
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.formatPrice(
                                                        _vm.amount
                                                      )
                                                    ) +
                                                    " " +
                                                    _vm._s(_vm.getCurrency) +
                                                    "\n                      "
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                ])
                              ])
                            ])
                          ]
                        )
                      ],
                      2
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ecae856", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ecae856","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/Transaction.vue
// module id = 0xVD
// module chunks = 1